import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'

import { useOnNavBack } from '@hooks'
import { BlueForm } from '@blueprinthq/joy-business'
import { useUserControllerGetIntervention } from '@api'
import { Loading, AppContainer } from '@components'

export const InterventionView = () => {
  const { userId, interventionId } = useParams()
  const navigate = useNavigate()
  useOnNavBack(() => navigate(-1))

  const { data: patientIntervention, isLoading }: { data: any; isLoading: Boolean } =
    useUserControllerGetIntervention(userId as string, interventionId as string)

  if (isLoading) return <Loading isFullPage />

  return (
    <AppContainer>
       <BlueForm
        title={patientIntervention.name}
        form={patientIntervention.interventionItems}
        isDisabled
        initialValues={patientIntervention.clientResponses}
      />
    </AppContainer>
  )
}
